import { render, staticRenderFns } from "./Marketmanagelist.vue?vue&type=template&id=2543fd1b&scoped=true"
import script from "./Marketmanagelist.vue?vue&type=script&lang=js"
export * from "./Marketmanagelist.vue?vue&type=script&lang=js"
import style0 from "./Marketmanagelist.vue?vue&type=style&index=0&id=2543fd1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2543fd1b",
  null
  
)

export default component.exports